function b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    let byteCharacters = atob(b64Data);
    let byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);

        let byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        let byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, {type: contentType});
}

function CREATE_FORM_DATA ( FORM_DATA, _k, state ){

    if( Array.isArray( state[ _k ] ) && state[ _k ].length ){

        if( _k === 'images' ){

            state[ _k ].forEach( function( item ) {

                if( ! ( item.indexOf(';base64,') >= 0 ) ) return;

                let block = item.split(";");
                let contentType = block[0].split(":")[1];
                let realData = block[1].split(",")[1];
                let blob = b64toBlob(realData, contentType);

                if(blob.size <= 20971520){
                    FORM_DATA.append( `${_k}[]`, blob )
                }

            } );

            return ;
        }

        state[ _k ].forEach( function( item ) {
            FORM_DATA.append( `${_k}[]`, item )
        } );

        return;
    }

    if( _k === 'description' ){
        const sanitize = /background(|-color)\:(\s*)((\#[a-zA-Z0-9]*(\;?))|\w*(\((\d*|\,|\s|\.)*\))(\;?))/gmi
        const res = state[ _k ].replaceAll( sanitize , '')
        return FORM_DATA.append( _k, res  )
    }

    FORM_DATA.append( _k, state[ _k ] );
}

function PET_VALIDATOR( target ){

    return {

        'validator'     : true,
        'petAvatar'     : true,
        'selectedCity'  : true,
        'previewImages' : true,
        'avatarPath'    : true,

        'not_moderated_fields' : true,
        'create_category'     : true,

        'weight' : ! target[ 'weight' ],
        'changed_moderated_fields' : ! target[ 'changed_moderated_fields' ],

        'avatar' : target[ 'avatarPath' ],

        'need_sum' : ( ! ( parseFloat(target[ 'need_sum' ] ) >= 0 ) ),
        'thx_text' : ( ! ( parseFloat(target[ 'need_sum' ] ) >= 0 ) ),

    }

}

function PERSONAL_VALIDATOR( target ){

    return {

        'validator'     : true,
        'petAvatar'     : true,
        'selectedCity'  : true,
        'previewImages' : true,

        'not_moderated_fields' : true,
        'changed_moderated_fields' : ! target[ 'changed_moderated_fields' ],

        'avatarPath' : target[ 'avatar' ],
        'avatar' : target[ 'avatarPath' ],

    }

}

function PROJECT_VALIDATOR( target ){

    return {

        'type'          : true,
        'validator'     : true,
        'petAvatar'     : true,
        'selectedCity'  : true,
        'previewImages' : true,

        'not_moderated_fields' : true,

        'avatarPath' : target[ 'avatar' ],
        'avatar' : target[ 'avatarPath' ],

    }

}

function FACILITIES_VALIDATOR( target ){

    return {

        'validator'           : true,
        'previewImages'       : true,
        'selectedCities'      : true,
        'selectedRegions'     : true,
        'not_moderated_fields' : true,

    }

}

function HOMESTAYS_VALIDATOR( target ){

    return {

        'validator'           : true,
        'selectedCity'        : true,
        'previewImages'       : true,
        'not_moderated_fields' : true,

    }

}

const REQUEST_VALIDATORS = {
    'PET_TYPE_VOLUNTEER' : PET_VALIDATOR,
    'PET_TYPE_MYSELF'    : PERSONAL_VALIDATOR,
    'PET_TYPE_PROJECT'   : PROJECT_VALIDATOR,
    'FACILITIES'         : FACILITIES_VALIDATOR,
    'HOMESTAYS'          : HOMESTAYS_VALIDATOR,
}


const publication = {
    pet:      {
        type: 'PET_TYPE_VOLUNTEER', create_category: null, city_id: null,
        pet_category_id: null, gender: null, pet_age_category_id: null,
        size: null, is_vaccinated: null, is_invalid: null, is_catch: null,
        is_parasite_treatment: null, is_sterilized: null, name: null,
        ad_title: null, description: null, petAvatar: null, avatar: null,
        previewImages: [], images: [], filters: [], to_children: 'null',
        to_dogs: 'null', to_cats: 'null', enrichment: 'null', human_sociability: 'null',
        need_sum: null, thx_text: null, weight: null, selectedCity: {name: null, id: null},
        delete_images: [], not_moderated_fields: [], changed_moderated_fields: null,
        avatarPath: null, validator: 'PET_TYPE_VOLUNTEER'
    },

    personal: {
        type: 'PET_TYPE_MYSELF', selectedCity: {name: null, id: null}, city_id: null,
        size: null, pet_category_id: null, gender: null, pet_age_category_id: null,
        is_vaccinated: null, is_invalid: null, is_catch: null, is_parasite_treatment: null,
        is_sterilized: null, name: null, ad_title: null, description: null, avatar: null,
        petAvatar: null, avatarPath: null, delete_images: [], previewImages: [], images: [],
        weight: null, to_children: null, to_dogs: 'null', to_cats: 'null', enrichment: 'null',
        human_sociability: 'null', is_donor: null, not_moderated_fields: [], validator: 'PET_TYPE_MYSELF'
    },

    project:  {
        type: 'PET_TYPE_PROJECT', project_category_id: null, name: null, ad_title: null,
        description: null, selectedCity: {name: null, id: null}, city_id: null, petAvatar: null,
        avatar: null, avatarPath: null, delete_images: [], previewImages: [], images: [],
        need_sum: null, allow_autopay: null, thx_text: null, not_moderated_fields: [],
        validator: 'PET_TYPE_PROJECT'

    },

    facility: {
        type: null, name: null, description: null, range: null, charge_category: null,
        cities: [], selectedCities: [], regions: [], images: [], previewImages: [],
        giveaway_category: null, selectedRegions: [], delete_images_ids: [],
        not_moderated_fields: [], validator: 'FACILITIES'
    },

    homestays: {
        city_id: null, street_address: null, type: null, name: null,
        description: null, pet_categories: [], charge_category: null,
        reception_status: null, min_duration: null, max_duration: null,
        view_mode: null, images: [], previewImages: [], not_moderated_fields: [],
        delete_images_ids: [], selectedCity: {name: null, id: null}, validator: 'HOMESTAYS',
    },

    empty: {}

};

const GET_DEFAULT_PUBLICATION = ( key ) => ( { target: {...publication[key] } } );

const state = { target: {} };

const getters = {
    GET_STATE: ( { target } )  =>  target,
    GET_BY_KEY:  ( { target } )  =>  ( key )  =>  target[ `${key}` ]
};

const mutations = {

    CREATE_STATE_BY_KEY: ( state, key ) => { Object.assign( state, GET_DEFAULT_PUBLICATION( key ) ) },

    SET_STATE_BY_MODEL:  ( { target }, model ) =>  Object.assign( target, model ),

    SET_PET_BY_KEY: ( { target }, { key, data } )  => {

        if(    target.not_moderated_fields.length && ! target.changed_moderated_fields
            && ! target.not_moderated_fields.includes( key )
        ) state.changed_moderated_fields = 1;

        target[`${key}`] = data
    },

    SET_PET_ARRAY_INDEX: ( { target }, { array, idx, data } ) => {

        if(    target.not_moderated_fields.length && ! target.changed_moderated_fields
            && ! target.not_moderated_fields.includes( array )
        ) target.changed_moderated_fields = 1;

        target[`${array}`]
            .splice(idx, 1,
                Object.assign({}, target[`${array}`][idx], data)
            )
    },

    SET_BY_KEY: ( { target }, { key, data } )  => target[`${key}`] = data,

    SET_ARRAY_INDEX: ( { target }, { array, idx, data } ) => {
        target[`${array}`]
            .splice(idx, 1,
                Object.assign({}, target[`${array}`][idx], data)
            )
    },


};

const actions = {

    async ACTION_STORE( { state: { target }, commit }, endpoint ){

        const validator = REQUEST_VALIDATORS[ target.validator ]( target );

        try {

            let FORM_DATA = new FormData();

            for( const _k in target ){

                if ( ! target[ _k ] && parseFloat(target[ _k ]) !== 0 ) continue;

                if ( Array.isArray( target[ _k ] ) && ! target[ _k ].length ) continue;

                if ( validator[ _k ] ) continue;

                CREATE_FORM_DATA(FORM_DATA, _k, target);

            }

            const success = await axios.post( endpoint, FORM_DATA, { header: { 'Content-Type': 'multipart/form-data' } } )
                .then( (res) => {
                    const { data = { success: false } } = res;
                    return data;
                } )
                .catch(function (error) {
                    if (error.response) {
                        if (error.response.status === 413) {
                            alert('Общий объем переданных данных превышает допустимый размер! Попробуйте уменьшить размер фотографий.');
                        }
                        return error.response.data;
                    } else {
                        throw error;
                    }
                })

            return success;

        } catch ( _e ){
            console.log( _e );
            alert('Произошла ошибка! Попробуйте перезагрузить страницу.');
        }

    },

};

export default {
    state,
    getters,
    mutations,
    actions,
}
